import { InformationIcon } from '@strata/react-status-icons';
import PropTypes from 'prop-types';

export const FieldFAQ = ({ faqText, tooltipText }) => (
    <div className="margin__top--large">
        <span className="sds_questions__text padding__right--small">{faqText}</span>
        <InformationIcon tooltipText={tooltipText} />
    </div>
);

FieldFAQ.propTypes = {
    faqText: PropTypes.string.isRequired,
    tooltipText: PropTypes.node.isRequired,
};
